import React from 'react';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { createStyles, makeStyles, Theme } from '@material-ui/core';
import MuiAlert from '@material-ui/lab/Alert';

const styles = makeStyles((theme: Theme) =>
  createStyles({
    myAlert: {
      color: 'black',
    },
  }),
);

const Alert = ({ layoutStyles, ...rest }) => {
  return (
    <MuiAlert
      className={layoutStyles.myAlert}
      elevation={6}
      variant="filled"
      {...rest}
    />
  );
};
const WarningBar: React.FC = () => {
  const layoutStyles = styles();
  const { ramWarningBarToggle, ramWarningMsg } = useFlags();

  return (
    <div>
      {ramWarningBarToggle && (
        <Alert severity="warning" layoutStyles={layoutStyles}>
          {ramWarningMsg}
        </Alert>
      )}
    </div>
  );
};

export default WarningBar;
